// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import gql from 'graphql-tag';
import * as React from 'react';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type GeneSearchQueryVariables = Types.Exact<{
  searchTerm?: Types.InputMaybe<Types.Scalars['String']>;
  page: Types.Scalars['Int'];
  selectedFacets?: Types.InputMaybe<Array<Types.FacetInput> | Types.FacetInput>;
  type?: Types.InputMaybe<Types.GeneSearchType>;
  sort?: Types.InputMaybe<Types.Sort>;
}>;


export type GeneSearchQuery = { __typename?: 'Query', getGeneSearchResults: { __typename?: 'GeneSearchResults', metadata: { __typename?: 'SearchResultsMetadata', itemCount?: number | null, page: number, perPage: number, numPages: number }, items: Array<{ __typename?: 'Gene', symbol: string, name?: string | null, summary?: string | null, synonyms: Array<string>, relatedCategories: Array<{ __typename?: 'GeneCategory', name: string }>, variants: Array<{ __typename?: 'GeneVariant', commonName: string, symbol: string, geneId: number, description: string, taxonId: number }> }>, facets: Array<{ __typename?: 'Facet', key: string, numToDisplay: number, isHidden?: boolean | null, isCollapsed: boolean, multiSelect: boolean, options: Array<{ __typename?: 'FacetOptions', value: string, count: number }> }> } };

export type GeneSearchFieldsFragment = { __typename?: 'GeneSearchResults', metadata: { __typename?: 'SearchResultsMetadata', itemCount?: number | null, page: number, perPage: number, numPages: number }, items: Array<{ __typename?: 'Gene', symbol: string, name?: string | null, summary?: string | null, synonyms: Array<string>, relatedCategories: Array<{ __typename?: 'GeneCategory', name: string }>, variants: Array<{ __typename?: 'GeneVariant', commonName: string, symbol: string, geneId: number, description: string, taxonId: number }> }>, facets: Array<{ __typename?: 'Facet', key: string, numToDisplay: number, isHidden?: boolean | null, isCollapsed: boolean, multiSelect: boolean, options: Array<{ __typename?: 'FacetOptions', value: string, count: number }> }> };

export type GeneFieldsFragment = { __typename?: 'Gene', symbol: string, name?: string | null, summary?: string | null, synonyms: Array<string>, relatedCategories: Array<{ __typename?: 'GeneCategory', name: string }>, variants: Array<{ __typename?: 'GeneVariant', commonName: string, symbol: string, geneId: number, description: string, taxonId: number }> };

export type GeneVariantFieldsFragment = { __typename?: 'GeneVariant', commonName: string, symbol: string, geneId: number, description: string, taxonId: number };

export const GeneVariantFieldsFragmentDoc = gql`
    fragment GeneVariantFields on GeneVariant {
  commonName
  symbol
  geneId
  description
  taxonId
}
    `;
export const GeneFieldsFragmentDoc = gql`
    fragment GeneFields on Gene {
  symbol
  name
  relatedCategories {
    name
  }
  summary
  synonyms
  variants {
    ...GeneVariantFields
  }
}
    ${GeneVariantFieldsFragmentDoc}`;
export const GeneSearchFieldsFragmentDoc = gql`
    fragment GeneSearchFields on GeneSearchResults {
  metadata {
    itemCount
    page
    perPage
    numPages
  }
  items {
    ...GeneFields
  }
  facets {
    key
    numToDisplay
    isHidden
    isCollapsed
    multiSelect
    options {
      value
      count
    }
  }
}
    ${GeneFieldsFragmentDoc}`;
export const GeneSearchDocument = gql`
    query GeneSearch($searchTerm: String, $page: Int!, $selectedFacets: [FacetInput!], $type: GeneSearchType, $sort: Sort) {
  getGeneSearchResults(
    input: {searchTerm: $searchTerm, pagination: {page: $page}, facets: $selectedFacets, type: $type, sort: $sort}
  ) {
    ...GeneSearchFields
  }
}
    ${GeneSearchFieldsFragmentDoc}`;
export type GeneSearchComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GeneSearchQuery, GeneSearchQueryVariables>, 'query'> & ({ variables: GeneSearchQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GeneSearchComponent = (props: GeneSearchComponentProps) => (
      <ApolloReactComponents.Query<GeneSearchQuery, GeneSearchQueryVariables> query={GeneSearchDocument} {...props} />
    );
    

/**
 * __useGeneSearchQuery__
 *
 * To run a query within a React component, call `useGeneSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneSearchQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      page: // value for 'page'
 *      selectedFacets: // value for 'selectedFacets'
 *      type: // value for 'type'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGeneSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GeneSearchQuery, GeneSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GeneSearchQuery, GeneSearchQueryVariables>(GeneSearchDocument, options);
      }
export function useGeneSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GeneSearchQuery, GeneSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GeneSearchQuery, GeneSearchQueryVariables>(GeneSearchDocument, options);
        }
export type GeneSearchQueryHookResult = ReturnType<typeof useGeneSearchQuery>;
export type GeneSearchLazyQueryHookResult = ReturnType<typeof useGeneSearchLazyQuery>;
export type GeneSearchQueryResult = ApolloReactCommon.QueryResult<GeneSearchQuery, GeneSearchQueryVariables>;